function Footer() {
  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-column">
          <h3>KNS Transport</h3>
          <p>Your trusted partner for goods transport across Southern India.</p>
        </div>

        <div className="footer-column">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#home" onClick={(e) => handleNavClick(e, 'home')}>Home</a></li>
            <li><a href="#about" onClick={(e) => handleNavClick(e, 'about')}>About Us</a></li>
            <li><a href="#services" onClick={(e) => handleNavClick(e, 'services')}>Services</a></li>
            <li><a href="#contact" onClick={(e) => handleNavClick(e, 'contact')}>Contact</a></li>
          </ul>
        </div>

        <div className="footer-column footer-contact-map">
        <div className="footer-contact">
          <h4>Head Office</h4>
          <p><i className="fas fa-map-marker-alt"></i> #11, Krishnappa Layout,<br/>Near Bus Stop, Bangarappa Nagar, Bangalore - 560085</p>
          <p><i className="fas fa-phone"></i> 9480763399 / 9480764499</p>
          <p><i className="fas fa-phone"></i> 9480743399 / 9035143199</p>
          <p><i className="fas fa-envelope"></i> knslogistic1@gmail.com</p>
        </div>

        <div className="footer-map">
          <iframe
            title="KNS Head Office Location"
            src="https://www.google.com/maps?q=12.922130770307223,77.5302861150776&z=16&output=embed"
            width="100%"
            height="150"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>

      </div>

      <div className="footer-bottom">
          <div className="footer-center"> © {new Date().getFullYear()} KNS Transport. All rights reserved. </div>
          <div className="footer-right">
            <span className="px-1">Designed & Developed by</span><a href="https://maheshkp-resume.netlify.app/" target="_blank" rel="noopener noreferrer" className="developer-link">
              <i className="fas fa-user-circle"></i> <strong>Mahesh Kumar K P</strong>
            </a>
          </div>
      </div>

    </footer>
  );
}

export default Footer;
